"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.externGetAtheneumContacts = externGetAtheneumContacts;
exports.geocodeByPlaceId = geocodeByPlaceId;
exports.getAccountSuggestions = getAccountSuggestions;
exports.getAtheneumContactSuggestions = getAtheneumContactSuggestions;
exports.getClientContactSuggestions = getClientContactSuggestions;
exports.getClientSuggestions = getClientSuggestions;
exports.getCompanySuggestions = getCompanySuggestions;
exports.getCvSourceSuggestions = getCvSourceSuggestions;
exports.getOfficeSuggestions = getOfficeSuggestions;
exports.getParentAccountSuggestions = getParentAccountSuggestions;
exports.getPlaceSuggestions = getPlaceSuggestions;
exports.getPositionSuggestions = getPositionSuggestions;
exports.getProjectSuggestions = getProjectSuggestions;
exports.searchEmployees = searchEmployees;

var _api = _interopRequireWildcard(require("./api"));

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function getCompanySuggestions(companyString) {
  var encodedCompanyString = encodeURIComponent(companyString);
  return _api["default"].get("/api/company/typeahead?q=".concat(encodedCompanyString)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getPositionSuggestions(positionString, limit) {
  var encodedPositionString = encodeURIComponent(positionString);
  var baseUrl = "/api/typeahead/positions?q=".concat(encodedPositionString);

  if (limit) {
    baseUrl = baseUrl + "&limit=".concat(limit);
  }

  return _api["default"].get(baseUrl).then(_api.extractData)["catch"](_api.errorHandler);
}

function getOfficeSuggestions(searchString, _ref) {
  var parentAccountId = _ref.parentAccountId,
      projectId = _ref.projectId;
  var payload = {
    searchString: searchString,
    projectId: projectId,
    parentAccountId: parentAccountId,
    limit: 50
  };
  return _api["default"].post('/api/office/typeahead-search', payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function getProjectSuggestions(projectString) {
  var encodedProjectString = encodeURIComponent(projectString);
  return _api["default"].get("/api/project/typeahead?q=".concat(encodedProjectString, "&open=true&pending=true")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAccountSuggestions(accountString) {
  var encodedAccountString = encodeURIComponent(accountString);
  return _api["default"].get("/api/account/typeahead?q=".concat(encodedAccountString)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getParentAccountSuggestions(parentAccountString) {
  var encodedParentAccountString = encodeURIComponent(parentAccountString);
  return _api["default"].get("/api/parent-account/typeahead-search?q=".concat(encodedParentAccountString)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getClientSuggestions(parentAccountId, clientString) {
  var encodedClientString = encodeURIComponent(clientString);
  return _api["default"].get("/api/client/typeahead-search?q=".concat(encodedClientString, "&parentAccountId=").concat(parentAccountId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getClientContactSuggestions(clientContactString) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var encodedClientContactString = encodeURIComponent(clientContactString);
  var query = "?q=".concat(encodedClientContactString);

  if (options.limit) {
    query = query + "&limit=".concat(options.limit);
  }

  if (options.parentAccountId) {
    query = query + "&parentAccountId=".concat(options.parentAccountId);
  }

  return _api["default"].get("/api/client/typeahead-search".concat(query)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAtheneumContactSuggestions(atheneumContactString, options) {
  var encodedAtheneumContactString = encodeURIComponent(atheneumContactString);
  var url = "/api/employee?query=".concat(encodedAtheneumContactString);

  if (options) {
    var params = _queryString["default"].stringify(options);

    url = url + '&' + params;
  }

  return _api["default"].get(url).then(_api.extractData)["catch"](_api.errorHandler);
}

function externGetAtheneumContacts(query) {
  var encoded = encodeURIComponent(query);
  var url = "/api/employee/extern-typeahead?q=".concat(encoded);
  return _api["default"].get(url).then(_api.extractData)["catch"](_api.errorHandler);
}

function searchEmployees(options) {
  var params = _queryString["default"].stringify(options);

  var url = "/api/employee/search?".concat(params);
  return _api["default"].get(url).then(_api.extractData)["catch"](_api.errorHandler);
}

function getPlaceSuggestions(placeString, types) {
  var encodedPlaceString = encodeURIComponent(placeString);
  return _api["default"].get("/api/googleplaces/autocomplete-places?input=".concat(encodedPlaceString, "&types=").concat(types)).then(_api.extractData)["catch"](_api.errorHandler);
}

function geocodeByPlaceId(placeId) {
  return _api["default"].get("/api/googleplaces/geocode-by-placeid?placeId=".concat(placeId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getCvSourceSuggestions(cvSourceString) {
  var encodedCvSourceString = encodeURIComponent(cvSourceString);
  return _api["default"].get("/api/cv-source/typeahead?q=".concat(encodedCvSourceString)).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  getCompanySuggestions: getCompanySuggestions,
  getPositionSuggestions: getPositionSuggestions,
  getOfficeSuggestions: getOfficeSuggestions,
  getProjectSuggestions: getProjectSuggestions,
  getAccountSuggestions: getAccountSuggestions,
  getParentAccountSuggestions: getParentAccountSuggestions,
  getClientSuggestions: getClientSuggestions,
  getClientContactSuggestions: getClientContactSuggestions,
  getAtheneumContactSuggestions: getAtheneumContactSuggestions,
  searchEmployees: searchEmployees,
  getPlaceSuggestions: getPlaceSuggestions,
  geocodeByPlaceId: geocodeByPlaceId
};
var _default = api;
exports["default"] = _default;